
import { useI18n } from 'vue-i18n';

export default {
  name: 'Navbar',
  setup(): {
    t: (key: string) => string;
  } {
    const { t } = useI18n();

    return {
      t,
    };
  },
};
